/** Shared F&O section taxonomy + P&L math (one source of truth). */

const isFutures = (row) => Boolean(row?.is_futures);
const isOpen = (row) => Boolean(row?.is_open);

export const FUTURES_OPTIONS_SECTIONS = [
  {
    key: "open-futures",
    title: "Futures - Open",
    totalLabel: "Total - Futures - Open",
    product: "Futures",
    rowFilter: (row) => isFutures(row) && isOpen(row),
  },
  {
    key: "closed-futures",
    title: "Futures - Closed",
    totalLabel: "Total - Futures - Closed",
    product: "Futures",
    rowFilter: (row) => isFutures(row) && !isOpen(row),
  },
  {
    key: "open-options",
    title: "Options - Open",
    totalLabel: "Total - Options - Open",
    product: "Options",
    rowFilter: (row) => !isFutures(row) && isOpen(row),
  },
  {
    key: "closed-options",
    title: "Options - Closed",
    totalLabel: "Total - Options - Closed",
    product: "Options",
    rowFilter: (row) => !isFutures(row) && !isOpen(row),
  },
];

export function sectionTitleForRow(row) {
  return FUTURES_OPTIONS_SECTIONS.find((section) => section.rowFilter(row))?.title ?? "Options - Closed";
}

export function productForRow(row) {
  return FUTURES_OPTIONS_SECTIONS.find((section) => section.rowFilter(row))?.product ?? "Options";
}

export function tradePnL(row) {
  return row?.is_open ? Number(row.market_value_open) || 0 : Number(row.market_value_closed) || 0;
}

export function offsetPnL(row) {
  return Number(row?.market_value_closed) || 0;
}

/** Sum Gain/Loss for an accordion group (lots + nested offsets, or single trade + its offsets). */
export function accordionSumPnL(row) {
  if (!row) return 0;
  if (row.is_combined) {
    return (row.lots || []).reduce((total, lot) => {
      const offsetTotal = (lot.offsets || []).reduce((sum, offset) => sum + offsetPnL(offset), 0);
      return total + tradePnL(lot) + offsetTotal;
    }, 0);
  }
  const offsetTotal = (row.offsets || []).reduce((sum, offset) => sum + offsetPnL(offset), 0);
  return tradePnL(row) + offsetTotal;
}

/** Totals G/L for raw main rows + their matched offsets. */
export function sumRowsGainLoss(rows, getMatch) {
  return (rows || []).reduce((total, row) => {
    const matched =
      getMatch?.(row.id)?.reduce((matchTotal, matchRow) => matchTotal + offsetPnL(matchRow), 0) || 0;
    return total + tradePnL(row) + matched;
  }, 0);
}
